import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Divider } from '../components/blocks/Divider';

export const isDivider = isElementType(Divider);
